'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp, _dec, _dec2, _class2, _class3, _temp2;

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components2 = require('../../components');

var _containers = require('containers');

var _info = require('redux/modules/info');

var _auth = require('redux/modules/auth');

var _docs = require('redux/modules/docs');

var _reduxRouter = require('redux-router');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components3 = require('components');

var _reactGoogleAnalytics = require('react-google-analytics');

var _reactGoogleAnalytics2 = _interopRequireDefault(_reactGoogleAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  HtmlRedirector: {
    displayName: 'HtmlRedirector'
  },
  App: {
    displayName: 'App'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/App/App.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { LinkContainer } from 'react-router-bootstrap';
// import { Navbar, NavBrand, Nav, NavItem, CollapsibleNav } from 'react-bootstrap';
//eslint-disable-line
// import { Glyphicon } from 'react-bootstrap';

// import DocumentMeta from 'react-document-meta';

// import { InfoBar } from 'components';
// import { SidePanel } from 'components';
// import { DocList } from 'components';

// import GoogleAnalytics from 'react-g-analytics';

// import { GoogleLogin, FacebookLogin } from 'components';


var GAInitiailizer = _reactGoogleAnalytics2.default.Initializer;

var HtmlRedirector = _wrapComponent('HtmlRedirector')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(HtmlRedirector, _Component);

  function HtmlRedirector() {
    (0, _classCallCheck3.default)(this, HtmlRedirector);
    return (0, _possibleConstructorReturn3.default)(this, (HtmlRedirector.__proto__ || (0, _getPrototypeOf2.default)(HtmlRedirector)).apply(this, arguments));
  }

  (0, _createClass3.default)(HtmlRedirector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window && location.hash.startsWith('#!') && !window.__redirecting) {
        window.__redirecting = true;
        var newUrl = location.hash.split('/')[0].substring(2);
        // target url is e.g. http://localhost:3000/?_escaped_fragment_=vkJEkCstpKNPWZKDH
        location.replace('/?_escaped_fragment_=' + newUrl);
      }
    }
    // tato komponeneta má za ukol pouze redirectovat tyto adresy http://localhost:3000/#!vkJEkCstpKNPWZKDH/Láska bláznivá
    //  na tvar   http://localhost:3000/?_escaped_fragment_=vkJEkCstpKNPWZKDH který už server umí zobrazit

  }, {
    key: 'render',
    value: function render() {
      return _react3.default.createElement('span', { style: { display: 'none' } });
    }
  }]);
  return HtmlRedirector;
}(_react2.Component), _class.propTypes = {}, _temp));

function fetchData(getState, dispatch) {
  var promises = [];
  // zde se kontroluje, zda je již naètený stav
  if (!(0, _info.isLoaded)(getState())) {
    promises.push(dispatch((0, _info.load)()));
  }
  if (!(0, _auth.isLoaded)(getState())) {
    promises.push(dispatch((0, _auth.load)()));
  }
  if (!(0, _docs.isPersonsLoaded)(getState())) {
    promises.push(dispatch((0, _docs.loadPersons)()));
  }
  return _promise2.default.all(promises);
}

var App = _wrapComponent('App')((_dec = (0, _connectData2.default)(fetchData), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { authState: state.auth, info: state.info };
}, { loginErrorReset: _auth.loginErrorReset, pushState: _reduxRouter.pushState, closeDialog: _info.closeDialog }), _dec(_class2 = _dec2(_class2 = (_temp2 = _class3 = function (_Component2) {
  (0, _inherits3.default)(App, _Component2);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!window.__gaRunned) {
        window.__gaRunned = true;
        (0, _reactGoogleAnalytics2.default)('create', 'UA-47491932-1', 'auto');
        (0, _reactGoogleAnalytics2.default)('send', 'pageview');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.authState.user && nextProps.authState.user) {
        // login
        // zatím neděláme nic , ale šlo by např. přesměrovat jinam: e.g.   this.props.pushState(null, '/loginSuccess');
      } else if (this.props.authState.user && !nextProps.authState.user) {
        // logout
        this.props.pushState(null, '/');
      }
    }

    // handleLogout = (event) => {
    //   event.preventDefault();
    //   this.props.logout();
    // }

  }, {
    key: 'render',
    value: function render() {
      var _props$authState = this.props.authState,
          user = _props$authState.user,
          loginError = _props$authState.loginError; // eslint-disable-line

      var _props = this.props,
          loginErrorReset = _props.loginErrorReset,
          closeDialog = _props.closeDialog,
          info = _props.info; // eslint-disable-line

      var _ref = info || {},
          dialog = _ref.dialog;

      var styles = require('./App.scss');
      var errorWindow = null;

      if (loginError) {
        //  = stary zpusob tvorby dialogu - jen pro loginError
        var msg = loginError.message || 'unknown error';
        errorWindow = _react3.default.createElement(
          _components2.Window,
          { title: 'Error', onClick: loginErrorReset },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'alert' }),
          ' ',
          msg
        );
      }

      var dialogWindow = null;
      if (dialog) {
        var _msg = dialog.msg || 'Are you sure ?';
        var msgBody = typeof _msg === 'function' ? _msg({ closeDialog: closeDialog }) : _msg;
        var ico = dialog.ico ? _react3.default.createElement(
          'span',
          null,
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: dialog.ico }),
          '\xA0\xA0\xA0'
        ) : null;
        var ctx = {
          closeDialog: closeDialog,
          dialog: dialog
        };
        var withClose = function withClose(origAction) {
          return origAction ? function () {
            origAction(ctx);if (dialog.autoClose !== false) closeDialog();
          } : null;
        };

        dialogWindow = _react3.default.createElement(
          _components2.Window,
          { title: dialog.title || 'Upozornění',
            onClick: withClose(dialog.onClick),
            onNoClick: withClose(dialog.onNoClick),
            okBtnText: dialog.okBtnText,
            okNoText: dialog.okNoText },
          ico,
          msgBody
        );
      }

      return _react3.default.createElement(
        'div',
        { className: styles.app },
        _react3.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react3.default.createElement(
          _reactBootstrap.Navbar,
          { fixedTop: true, inverse: true, fluid: true, itemScope: true, itemType: 'http://schema.org/SiteNavigationElement' },
          _react3.default.createElement(
            _reactBootstrap.Navbar.Header,
            null,
            _react3.default.createElement(
              _reactBootstrap.Navbar.Brand,
              null,
              _react3.default.createElement(
                _reactRouter.IndexLink,
                { to: '/', activeStyle: { color: '#33e0ff' } },
                _react3.default.createElement(
                  'div',
                  { className: styles.brand },
                  _react3.default.createElement('div', null)
                )
              ),
              _react3.default.createElement(_components3.AutoComplete, null)
            ),
            _react3.default.createElement(_reactBootstrap.Navbar.Toggle, null)
          ),
          _react3.default.createElement(
            _reactBootstrap.Navbar.Collapse,
            { expanded: true },
            _react3.default.createElement(
              _reactBootstrap.Navbar.Brand,
              null,
              _react3.default.createElement(
                _reactRouter.IndexLink,
                { to: '/', activeStyle: { color: 'white' }, className: styles.appName },
                _react3.default.createElement(
                  'span',
                  null,
                  _config2.default.app.menuTitle,
                  ' ',
                  _config2.default.app.night ? 'NightlyBuild' : '',
                  ' ',
                  _react3.default.createElement(
                    'sup',
                    { className: 'landscapeOnly' },
                    _config2.default.app.version
                  )
                )
              )
            ),
            _react3.default.createElement(
              _reactBootstrap.Nav,
              { navbar: true, pullRight: true },
              _react3.default.createElement(
                _containers.MainMenu,
                null,
                _react3.default.createElement(_containers.MainMenuContent, null)
              ),
              _react3.default.createElement(_components3.Menu1, null),
              _react3.default.createElement(_components3.LoginMenu, null)
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { className: styles.appContent },
          this.props.children
        ),
        dialogWindow,
        errorWindow,
        _react3.default.createElement(HtmlRedirector, null),
        _react3.default.createElement(GAInitiailizer, null)
      );
    }
  }]);
  return App;
}(_react2.Component), _class3.propTypes = {
  children: _react2.PropTypes.object.isRequired,
  authState: _react2.PropTypes.object,
  loginErrorReset: _react2.PropTypes.func.isRequired,
  pushState: _react2.PropTypes.func.isRequired,
  closeDialog: _react2.PropTypes.func.isRequired,
  info: _react2.PropTypes.object
}, _class3.contextTypes = {
  store: _react2.PropTypes.object.isRequired
}, _temp2)) || _class2) || _class2));

exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1204
// module chunks = 0